var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90478 24H27.0952C29.6896 24 31 22.6748 31 20.1303V3.86969C31 1.32523 29.6896 0 27.0952 0H3.90478C1.32366 0 0 1.31198 0 3.86969V20.1303C0 22.688 1.32366 24 3.90478 24ZM9.54355 12.2717C7.76986 12.2717 6.32707 10.8139 6.32707 9.0381C6.32707 7.27554 7.76986 5.81778 9.54355 5.81778C11.304 5.81778 12.7468 7.27554 12.7468 9.0381C12.7468 10.8139 11.304 12.2717 9.54355 12.2717ZM3.89155 22.37C2.48847 22.37 1.64133 21.5351 1.64133 20.1171V19.4014L6.03587 15.598C6.64475 15.0679 7.2801 14.7896 7.86251 14.7896C8.5111 14.7896 9.18617 15.0679 9.78181 15.6245L12.2703 17.8774L18.6106 12.3114C19.2989 11.7018 20.0534 11.4103 20.7814 11.4103C21.5359 11.4103 22.3168 11.7151 22.9787 12.3247L29.3587 18.1557V20.1303C29.3587 21.5351 28.5115 22.37 27.1217 22.37H3.89155Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo-icon.214f12c08be1bf6b5cea2b92d32b1c00.svg";
export { ForwardRef as ReactComponent };